import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'getTestimonialTemplate';

const TEMPLATE_CACHE_MS = 5 * 60 * 1000;

export const useGetTestimonialTemplate = ({
	enabled = true,
	impersonationContext,
	meta,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
	meta?: LevStandardQueryMeta;
} = {}) => {
	const userSession = useUserSession();

	return useQuery({
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IGoogleReviewPostTemplateDocument>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'googleBusiness/testimonial/template',
				}),
				'GET'
			);
		},
		enabled,
		meta,
		queryKey: [BASE_QUERY_KEY, impersonationContext],
		refetchOnWindowFocus: false,
		staleTime: TEMPLATE_CACHE_MS,
		gcTime: TEMPLATE_CACHE_MS,
	});
};

export const invalidateTestimonialTemplate = ({
	impersonationContext,
}: {
	impersonationContext?: Api.IImpersonationContext;
} = {}) => {
	return reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY, impersonationContext] });
};
